import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SOTService } from '../../services';

@Component({
  selector: "sot-pagerconfirmation",
  templateUrl: "./pagerconfirmation.component.html",
  styleUrls: ["./pagerconfirmation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagerConfirmationComponent implements OnInit, OnDestroy {

  private _resetAfterPaymentSubscription: Subscription;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-pagerconfirmation constructor")
  }
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  public ngOnInit(): void {
    console.debug("--- sot-pagerconfirmation ngOnInit")
    const me = this;
    me._resetAfterPaymentSubscription = me._sotService.evResetAfterPayment.subscribe(() => { me.resetAfterPaymentComplete() });
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-pagerconfirmation ngOnDestroy")
    if (this._resetAfterPaymentSubscription) {
      this._resetAfterPaymentSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("PagerConfirmationComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get order_no(): string {
    return this._sotService.currentOrderNo;
  }

  /** reagiert, wenn das POS mitteilt das der Bon gezogen wurde */
  private resetAfterPaymentComplete(): void {
    this._sotService.GoToStartscreen();
  }

  public countdownStatusChanged(status: "start" | "stop" | "done"): void {
    if (status == "done") {
      this._sotService.GoToStartscreen();
      this._sotService.StopInactiveDialogTimer();
    } // else ignore
    else if (status == "stop") {
      this._sotService.StartInactiveDialogTimer();
    } else {
      this._sotService.StopInactiveDialogTimer();
    }
  }

  public get show_questions(): boolean {
    return false; // momentan werden keine fragen gestellt
  }
}

